module.exports = __webpack_public_path__ + "video.png?56b0867670b082039a0b3a4eb391d52a";